import React from 'react'
// @src imports
import { BottomNav, defaultItems } from 'src/chrome/BottomNav/BottomNav'
import CardHistoryManager from 'src/card_history/containers/CardHistoryManager'
import DraftedCards from 'src/drafts/containers/DraftedCards'
import { AccountRoute } from 'src/dashboard/routes/AccountRoute'
import {
  DashboardRoute,
  DashboardSubroute,
} from 'src/dashboard/routes/DashboardRoute'
import { DraftedOrdersRoute } from 'src/dashboard/routes/DraftedOrdersRoute'
import { DraftedCardsRoute } from 'src/dashboard/routes/DraftedCardsRoute'
import { InvitesRoute } from 'src/dashboard/routes/InvitesRoute'
import { NotificationsRoute } from 'src/dashboard/routes/NotificationsRoute'
import { PaymentSettingsRoute } from 'src/dashboard/routes/PaymentSettingsRoute'
import { PurchasePointsRoute } from 'src/dashboard/routes/PurchasePointsRoute'
import { CardHistoryRoute } from 'src/dashboard/routes/CardHistoryRoute'
import { DashboardHeader, DashboardNav } from 'src/dashboard/components'
import { DefaultError, SuspenseBoundary } from 'src/chrome'
// relative imports
import Account from '../Account'
import DraftedOrders from '../DraftedOrders'
import Invites from '../Invites/Invites'
import Notifications from '../Notifications/Notifications'
import PaymentSettings from '../PaymentSettings/PaymentSettings'
import AnnouncementBanners from '../../../marketing/AnnouncementBanners/AnnouncementBanners'
import styles from './styles'
import { PricingRoute } from 'src/marketing/plans/routes/PricingRoute'
import { CoachingRoute } from 'src/dashboard/routes/CoachingRoute'
import Coaching from 'src/coaching/containers/Coaching'
import { LeaderBoardRoute } from 'src/dashboard/routes/LeaderBoardRoute'
import { LeaderBoardList } from 'src/dashboard/components/Leaderboard/LeaderBoardList'
import { PricingPage } from 'src/pricing_page/PricingPage'
import { DropDownMenuProps, Flex } from '@sendoutcards/quantum-design-ui'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'

import { sponsorParam } from 'src/dashboard/navigationData'
import { AccountFragment } from 'src/legacy_graphql'

export const dropDownMenuLinks = (
  account?: AccountFragment,
): DropDownMenuProps => {
  const sponsorLinkParam = account ? sponsorParam(account) : ''

  return {
    linkColumn: {
      title: '',
      links: [
        {
          title: (
            <Flex flexDirection="column">
              <Icon name="soc_logo" size={200} color="#000" />
              <Flex
                alignItems="center"
                style={{
                  fontFamily: 'Ubuntu',
                  fontStyle: 'italic',
                  fontSize: '14px',
                }}
                justifyContent="flex-end"
                flexDirection="row"
                columnGap="x_25"
              >
                The
                <Icon name="promptings_logo_full" size={90} color="#000" />
                Mechanism
              </Flex>
            </Flex>
          ),
          href: '/app',
          target: '_self',
        },
        {
          title: (
            <Flex flexDirection="column">
              <Icon name="promptings_logo_full" size={170} color="#000" />
              <Flex
                alignItems="center"
                style={{
                  fontFamily: 'Ubuntu',
                  fontStyle: 'italic',
                  fontSize: '14px',
                }}
                justifyContent="flex-end"
                flexDirection="row"
                columnGap="x_5"
              >
                Powered by
                <Icon name="soc_logo" size={120} color="#000" />
              </Flex>
            </Flex>
          ),
          onClick: () =>
            window.open(`https://www.promptings.com/${sponsorLinkParam}`),
          href: '',
          target: '_blank',
        },
      ],
    },
    top: 60,
    isOpen: false,
  }
}
type DashboardProps = {
  route: DashboardRoute
}

const Dashboard: React.FC<DashboardProps> = props => {
  const { route } = props

  const routePath = route.subroute.path

  const showSidebar = !DashboardSubroute.hideSidebar(route.subroute)

  return (
    <div>
      {showSidebar && (
        <div css={styles.dashboardNavContainer}>
          <DashboardNav />
        </div>
      )}
      <div css={styles.bottomNavWrapper}>
        <div css={styles.bottomNav}>
          <BottomNav
            items={defaultItems}
            rootCSS={styles.rootNavWrapper}
            drawerItems={<DashboardNav />}
          />
        </div>
      </div>
      <div css={styles.dashboardWrapper}>
        <DashboardHeader routePath={routePath} />
        <div css={styles.dashboardContainer(routePath === '/account')}>
          <AnnouncementBanners />
          {routePath === AccountRoute.path && (
            <SuspenseBoundary
              unresolved={''}
              failure={() => {
                const accountError = new Error(
                  'There was an error loading your account. Please reload and try again',
                )
                return DefaultError(accountError)
              }}
            >
              <Account />
            </SuspenseBoundary>
          )}
          {routePath === DraftedOrdersRoute.path && <DraftedOrders />}
          {routePath === DraftedCardsRoute.path && (
            <DraftedCards isWrapContentEnabled={true} />
          )}
          {routePath === InvitesRoute.path && <Invites />}
          {routePath === NotificationsRoute.path && <Notifications />}
          {route.subroute.path === CardHistoryRoute.path && (
            <CardHistoryManager
              route={route.subroute}
              initialSection={(route.subroute as CardHistoryRoute).section}
              initialFilters={(route.subroute as CardHistoryRoute).filters}
            />
          )}
          {routePath === PaymentSettingsRoute.path && <PaymentSettings />}
          {routePath === PurchasePointsRoute.path && <PricingPage />}
          {routePath === PricingRoute.path && <PricingPage />}
          {routePath === CoachingRoute.path && <Coaching />}
          {routePath === LeaderBoardRoute.path && <LeaderBoardList />}
        </div>
      </div>
    </div>
  )
}

export default Dashboard
